<div class="relative">
  <div *ngIf="enableSearch()">
    <!-- Search Input -->
    <lib-custom-input
      [formControl]="searchControl"
      [label]="label()"
      [placeholder]="'SHARED.INPUTS_CUSTOM-MAP-INPUT.SEARCH_PLACEHOLDER' | translate"
      [displayError]="true"
      (inputBlur)="onTouched()"
      [clearable]="selectionType === 'single'"
      (cleared)="onSearchCleared()"
    ></lib-custom-input>

    <!-- Search Results Dropdown -->
    <ng-container *ngIf="searchResults$ | async as searchResults">
      <ul
        *ngIf="searchResults.length > 0"
        class="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 shadow-lg"
      >
        <li
          *ngFor="let place of searchResults"
          (click)="selectPlace(place)"
          class="px-2 py-1 cursor-pointer hover:bg-gray-200"
        >
          <div class="font-bold">{{ place.name }}</div>
          <div class="text-[14px] text-gray-600">{{ place.formatted_address }}</div>
        </li>
      </ul>
    </ng-container>

    <!-- Validator Info -->
    <div
      *ngIf="(maxLocations || minLocations) && enableTotalLocations()"
      class="text-[14px] text-gray-600 mt-4 pl-1"
    >
      <span>
        {{ 'SHARED.INPUTS_CUSTOM-MAP-INPUT.LOCATIONS_LABEL' | translate }}:
        {{ locationControls.controls.length }}
      </span>
      <span *ngIf="maxLocations">
        {{ 'SHARED.INPUTS_CUSTOM-MAP-INPUT.OF_LABEL' | translate }} {{ maxLocations }}
      </span>
      <span *ngIf="minLocations">
        ({{ 'SHARED.INPUTS_CUSTOM-MAP-INPUT.MINIMUM_LABEL' | translate }} {{ minLocations }})
      </span>
    </div>

    <!-- Selected Locations List -->
    <div
      *ngIf="locationControls.controls.length > 0 && selectionType !== 'single'"
      class="mt-4 space-y-2"
    >
      <div
        *ngFor="let control of locationControls.controls; let i = index"
        class="flex items-center gap-2 p-2 border rounded-md bg-gray-50 cursor-pointer hover:bg-gray-100"
        (click)="centerMapOnLocation(i)"
      >
        <span class="font-bold text-gray-600">{{ i + 1 }}</span>
        <input
          [formControl]="control"
          class="flex-grow p-1 bg-transparent focus:outline-none"
          readonly
        />
        <button
          *ngIf="!isDisabled"
          type="button"
          (click)="removeLocation(i); $event.stopPropagation()"
          class="text-red-500 hover:text-red-700 font-bold"
        >
          &times;
        </button>
      </div>
    </div>

    <!-- Error Display (Moved below input) -->
    <lib-custom-error-display [errors]="errors()" [control]="ngControl"></lib-custom-error-display>
  </div>

  <!-- Map -->
  <div *ngIf="isGoogleMapsApiLoaded" class="mt-4">
    <google-map height="400px" width="100%" [options]="mapOptions" (mapClick)="mapClick($event)">
      <map-marker
        *ngFor="let marker of markers; let i = index"
        [options]="marker"
        (mapDragend)="onMarkerDragEnd($event, i)"
      ></map-marker>
    </google-map>
  </div>
</div>
